export class RunOnHoldProjectReleaseDTO {

    labId: string;
    listofProjectName: string[];
    constraintType: string;
    constraintId : string;
    totalLibs:number;
    libraryIds: string[];
    submitConfirmed: boolean;
}